import React from 'react'
import TabLayout from "./tabLayout"
import {ListContactContextProvider} from "../../manager-contact/context/ListContactContext"
import {SettingTenantProvider} from "../../setting-tenant/context/SettingTenantContext"
import {SettingTenantDealerProvider} from "../../setting-tenant-agency/context/SettingTenantDealerContext"

const ContextContainer = (props) => {
    const loadContext = (patch) => {
        switch (patch) {
            case '/crm/dashboard':
                return <TabLayout type='dashboard'/>
            case '/crm/task':
                return <TabLayout type='task'/>
            case '/crm/manager-contact':
                return (
                    <ListContactContextProvider>
                        <TabLayout type='contact'/>
                        {props.children}
                    </ListContactContextProvider>
                )
            case '/crm/manager-user':
                return <TabLayout type='settingUser'/>
            case '/crm/setting-tenant':
                return (
                    <SettingTenantProvider>
                        <TabLayout type='settingTenant'/>
                        {props.children}
                    </SettingTenantProvider>
                )
            case '/crm/setting-tenant-dealer':
                return (
                    <SettingTenantDealerProvider>
                        <TabLayout type='settingTenantDealer'/>
                        {props.children}
                    </SettingTenantDealerProvider>
                )
            case '/crm/customers':
                return <TabLayout type='customers'/>
            case '/crm/customers-hub':
                return <TabLayout type='customersHub'/>
            case '/crm/phone-number-hub':
                return <TabLayout type='phoneNumberHub'/>
            case '/crm/report-phone-out':
                return <TabLayout type='reportPhoneOut'/>
            case '/crm/report-agent':
                return <TabLayout type='reportAgent'/>
            case '/crm/report-agent-v1':
                return <TabLayout type='reportAgentV1'/>
            case '/crm/report-agent-v2':
                return <TabLayout type='reportAgentV2'/>
            case '/crm/report-campaign':
                return <TabLayout type='reportCampaign'/>
            case '/crm/report-sale-process':
                return <TabLayout type='reportSaleProcess'/>
            case '/crm/report-sale':
                return <TabLayout type='reportSale'/>
            case '/crm/report-sale-finish':
                return <TabLayout type='reportSaleFinish'/>
            case '/crm/report-tech-total':
                return <TabLayout type='reportTechTotal'/>
            case '/crm/report-tech':
                return <TabLayout type='reportTech'/>
            case '/crm/report-order':
                return <TabLayout type='reportOrder'/>
            case '/crm/report-key-click':
                return <TabLayout type='reportKeyClick'/>
            case '/crm/report-predictive':
                return <TabLayout type='reportPredictive'/>
            case '/crm/report-predictive-v1':
                return <TabLayout type='reportPredictiveV1'/>
            case '/crm/report-predictive-tts-v1':
                return <TabLayout type='reportPredictiveTTSV1'/>
            case '/crm/monitoring':
                return <TabLayout type='monitoring'/>
            case '/crm/report-lead-by-status':
                return <TabLayout type='reportLeadByStatus'/>
            case '/crm/report-by-day':
                return <TabLayout type='reportByDay'/>
            case '/crm/report-by-staff':
                return <TabLayout type='reportByStaff'/>
            default:
                return props.children
        }
    }


    return (
        <div className="ContextContainer">
            {loadContext(props.path)}
        </div>
    )
}

export default ContextContainer
